<script lang="ts">
	let { src }: { src: string } = $props();
</script>

<div id="virtual-tour" class="mb-8">
	<h2 class="mb-4 text-2xl font-bold">Virtual Tour</h2>
	<iframe
		title="Matterport Tour"
		class="aspect-video w-full"
		{src}
		frameborder="0"
		allow="autoplay; fullscreen; web-share; xr-spatial-tracking;"
	></iframe>
</div>
